import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "../../css/LandingPage.css";
import Header from "../PublicHeader";
import Footer from "../Footer";
import { Helmet } from "react-helmet-async";
import PublicChatbotDemo from "./PublicChatbotDemo";
import LivePreview from "./LivePreview";




export default function LandingPage() {

    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    return (
        <div className="landing-page bg-gradient-to-b from-white to-blue-50 text-gray-800">

            <Helmet>
                <title>SavoryBot - AI Chatbot for Restaurants</title>
                <meta name="description"
                      content="Boost restaurant engagement and sales with SavoryBot, your AI-powered food chatbot. Free 7-day trial!"/>
                <meta name="keywords"
                      content="restaurant chatbot, AI food assistant, restaurant automation, savorybot"/>
                <meta name="robots" content="index, follow"/>
                <link rel="canonical" href="https://savoryai.io/"/>
                {/* Open Graph */}
                <meta property="og:title" content="SavoryBot - AI Chatbot for Restaurants"/>
                <meta property="og:description"
                      content="Engage customers with intelligent food suggestions. Try SavoryBot for free!"/>
                <meta property="og:image" content="https://savoryai.io/og-banner.png"/>
                <meta property="og:url" content="https://savoryai.io/"/>
                <meta property="og:type" content="website"/>

                {/* Twitter Card */}
                <meta name="twitter:card" content="summary_large_image"/>
                <meta name="twitter:title" content="SavoryBot - AI Chatbot for Restaurants"/>
                <meta name="twitter:description"
                      content="Engage customers with intelligent food suggestions. Try SavoryBot for free!"/>
                <meta name="twitter:image" content="https://savoryai.io/og-banner.png"/>

            </Helmet>

            <Header/>

            {/* Hero Section */}
            {/* <section className="hero py-20 bg-gradient-to-b from-blue-700 to-blue-900 text-white text-center"
                     data-aos="fade-up">
                <div className="container mx-auto px-4">
                    <h1 className="text-5xl font-extrabold leading-tight mb-4">
                        Elevate Your Restaurant with AI 🍽️
                    </h1>
                    <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
                        Boost engagement, drive sales, and enhance customer experience using our smart chatbot platform.
                    </p>
                    <a
                        href="/login"
                        className="inline-block bg-white text-blue-700 px-6 py-3 rounded-full font-semibold shadow hover:bg-blue-50 transition animate-bounce"
                    >
                        🚀 Get a 14-Day Free Trial
                    </a>
                </div>
            </section> */}

            {/* Hero Section */}
            <section className="hero relative overflow-hidden bg-gradient-to-br from-blue-700 via-indigo-700 to-purple-700 text-white">
                <div className="container mx-auto px-6 py-20 lg:py-28">
                    <div className="mx-auto max-w-4xl text-center">

      <span className="inline-flex items-center rounded-full border border-white/20 bg-white/10 px-4 py-2 text-sm font-medium text-blue-100">
        AI-Powered Menu Assistant for Restaurants
      </span>

                        <h1 className="mt-7 text-4xl font-extrabold tracking-tight leading-tight sm:text-5xl lg:text-6xl">
                            Help Every Guest Find
                            <span className="block text-blue-100">
          Their Next Favorite Dish
        </span>
                        </h1>

                        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-blue-100 sm:text-xl">
                            Turn your restaurant menu into an interactive experience.
                            Help customers explore dishes, discover personalized
                            recommendations, and find meals that fit their preferences
                            and budget.
                        </p>

                        <div className="mt-9 flex flex-col items-center justify-center gap-4 sm:flex-row">
                            <a
                                href="#live-demo"
                                className="inline-flex min-h-12 items-center justify-center rounded-full bg-white px-8 py-3 font-semibold text-blue-700 shadow-lg transition hover:bg-blue-50"
                            >
                                Try SavoryBot Live
                            </a>

                            <a
                                href="/login"
                                className="inline-flex min-h-12 items-center justify-center rounded-full border border-white/50 px-8 py-3 font-semibold text-white transition hover:bg-white/10"
                            >
                                Start Your 14-Day Free Trial
                            </a>
                        </div>

                        <p className="mt-5 text-sm text-blue-100">
                            Built for independent restaurants and growing food businesses.
                        </p>

                    </div>
                </div>
            </section>

            <section className="features py-20 bg-white" data-aos="fade-up">
                <div className="container mx-auto px-4">
                    <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">Why Choose Us?</h2>
                    <div className="grid md:grid-cols-3 gap-8">
                        <div className="feature-card p-6 bg-blue-50 rounded-xl shadow hover:shadow-lg transition"
                             data-aos="zoom-in">
                            <h3 className="text-xl font-semibold mb-2 text-blue-700">💬 Smart Chatbot</h3>
                            <p className="text-gray-600">
                                Delight your customers with instant food suggestions based on cravings, weather, and
                                more.
                            </p>
                        </div>
                        <div className="feature-card p-6 bg-blue-50 rounded-xl shadow hover:shadow-lg transition"
                             data-aos="zoom-in" data-aos-delay="100">
                            <h3 className="text-xl font-semibold mb-2 text-blue-700">⚙️ Fully Customizable</h3>
                            <p className="text-gray-600">
                                Personalize the chatbot’s appearance to match your brand seamlessly.
                            </p>
                        </div>
                        <div className="feature-card p-6 bg-blue-50 rounded-xl shadow hover:shadow-lg transition"
                             data-aos="zoom-in" data-aos-delay="200">
                            <h3 className="text-xl font-semibold mb-2 text-blue-700">📊 Powerful Analytics</h3>
                            <p className="text-gray-600">
                                Understand your customers better with real-time insights and chat trends.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="testimonials py-20 bg-gradient-to-r from-blue-50 to-white" data-aos="fade-up">
                <div className="container mx-auto px-4">
                    <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">What Our Customers Say</h2>
                    <div className="grid md:grid-cols-2 gap-8">
                        <div className="testimonial p-6 bg-white rounded-xl shadow hover:shadow-md transition"
                             data-aos="fade-right">
                            <p className="text-lg italic text-gray-700">
                                “We’ve just started using the chatbot, and we're already seeing how much it improves
                                customer interaction. Super promising so far!”
                            </p>
                            <span className="block mt-4 font-semibold text-blue-700">– Huy Nguyen, Balô Kitchen</span>
                        </div>
                        <div className="testimonial p-6 bg-white rounded-xl shadow hover:shadow-md transition"
                             data-aos="fade-left">
                            <p className="text-lg italic text-gray-700">
                                “The setup was smooth and the responses feel natural. It's like having an assistant that
                                never sleeps!”
                            </p>
                            <span className="block mt-4 font-semibold text-blue-700">– Long Lai, Balô Kitchen</span>
                        </div>
                    </div>
                </div>
            </section>


            {/* Real interactive demo */}
            <PublicChatbotDemo />

            {/* Product screenshots */}
            <LivePreview />


            {/* FAQ Section */}
            <section className="faq py-20 bg-white border-t" data-aos="fade-up">
                <div className="container mx-auto px-4 max-w-3xl">
                    <h2 className="text-3xl font-bold text-center mb-8 text-gray-800"> Frequently Asked Questions</h2>
                    <div className="space-y-4">
                        {[
                            {
                                question: "💳 Do I need a credit card for the trial?",
                                answer: "Yes, a card is required to start the 14-day free trial, but you won’t be charged until the trial ends. You can cancel anytime before."
                            },
                            {
                                question: "❓ What happens after my trial ends?",
                                answer: "You’ll be charged automatically for your selected plan unless you cancel before the trial ends. We’ll remind you before that happens."
                            },
                            {
                                question: "🛠️ How easy is setup?",
                                answer: "Super easy! You can embed your chatbot in your site with one line of code and start customizing in minutes. No coding skills required."
                            },
                            {
                                question: "📈 Can I track usage and performance?",
                                answer: "Yes, you get access to detailed chatbot analytics to understand engagement and top-performing dishes."
                            },
                            {
                                question: "🧠 Does the AI support menu recommendations?",
                                answer: "Yes! It intelligently suggests food based on cravings, weather, budget, and time of day."
                            },
                            {
                                question: "🔐 Is my data secure?",
                                answer: "Absolutely. We use industry-standard encryption and best practices to protect your data."
                            }
                        ].map((faq, idx) => (
                            <details key={idx} className="border border-gray-200 rounded-lg p-4 shadow-sm transition">
                                <summary className="cursor-pointer font-medium text-gray-800">{faq.question}</summary>
                                <p className="mt-2 text-gray-600">{faq.answer}</p>
                            </details>
                        ))}
                    </div>
                </div>
            </section>


            <Footer/>
        </div>
    );
}
